import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { ComponentsModule } from '@jht/brand-components';
import { TranslateModule } from '@jht/brand-translate';

import { StateSelectorComponent } from './state-selector/state-selector.component';
import { CountrySelectorComponent } from './country-selector/country-selector.component';

@NgModule({
    declarations: [StateSelectorComponent, CountrySelectorComponent],
    imports: [CommonModule, ComponentsModule, TranslateModule],
    exports: [StateSelectorComponent, CountrySelectorComponent],
})
export class StateCountrySelectorModule {}
